import { Component, OnInit } from '@angular/core';
import { SessionService } from "../../services/session.service";
import { environment } from "../../../environments/environment";

@Component({
  selector: 'app-ministry-dashboard',
  templateUrl: './ministry-dashboard.component.html',
  styleUrls: ['./ministry-dashboard.component.css']
})
export class MinistryDashboardComponent implements OnInit {

  applicationId: any;
  ministry_of_health_appId: any;

  constructor(private sess: SessionService ) { }

  ngOnInit() {
    this.sess.checkLogin();

    this.applicationId = localStorage.getItem('application_id');
    this.ministry_of_health_appId = environment.APP_ID_MINISTRY_OF_HEALTH;
		this.sess.confirmUser(this.applicationId, this.ministry_of_health_appId, 'Ministry Of Health');
  }

}
